import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/course/quiz/list`, { params })
  return response.data
}

const getAllTemp = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/course/quiz/list-temp`, { params })
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/course/quiz/show-temp/${data}`)
  return response.data //should be return response.data
}

const createQuiz = async (data) => {
  const response = await AuthAPI.post(`/admin/course/quiz/create`, data) 
  return response.data
}

const editQuiz = async (data) => {
  const response = await AuthAPI.post(`/admin/course/quiz/update`, data)
  return response.data
}

const deleteOne = async (data) => {
  const response = await AuthAPI.delete(`/admin/subject/delete/${data}`)
  return response.data
}

const deleteOneTemp = async (data) => {
  const response = await AuthAPI.delete(`/admin/course/quiz/delete-temp/${data}`)
  return response.data
}

export const quizService = {
  getAll,
  getAllTemp,
  getOne,
  createQuiz,
  editQuiz,
  deleteOne,
  deleteOneTemp,
}
